import { ParentModel } from '@blueprint/frontend-basics'
import { IsNotEmpty, IsOptional, IsString, IsUUID } from 'class-validator'

export class TaleDto extends ParentModel {
  @IsUUID()
  @IsOptional()
  id?: string

  @IsString()
  @IsNotEmpty()
  title?: string

  constructor() {
    super()
  }
}
